import { RESTClient } from './client';
import { API_URL } from './apiDictionary';
import { UploadFileTypeEnum } from '@dynamika-shared/types/inventory';
import { UploadFormData } from '@components/SiteUserUpload/types/uploadTypes';
import { prepareUrl } from '@utils/routerHelpers';

export const fetchValidationSpecialistQuestionnaires = async (
  clinicalTrialId: string,
  dataType: UploadFileTypeEnum,
  visitDefinitionId: string,
) => {
  const response = await RESTClient.get<UploadFormData[]>(
    API_URL.validationSpecialistQuestionnaires,
    {
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
      params: {
        dataType,
        visitDefinitionId,
      },
    }
  );

  return response.data;
};

type UpdateParticipantFormArgs = {
  data: object;
  uploadItemId: string;
  questionnaireId: string;
  clinicalTrialId: string;
};

export const updateParticipantForm = async (args: UpdateParticipantFormArgs) => {
  const { data, uploadItemId, questionnaireId, clinicalTrialId } = args;
  return RESTClient.put(
    prepareUrl(API_URL.validationSpecialistUpdateQuestionnaire, [uploadItemId]),
    {
      questionnaireId,
      response: data,
    },
    {
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
    }
  );
};
